<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <template v-slot:activator="{ on, attrs }">
        <v-btn v-on="on" v-bind="attrs" color="white" text rounded>Privacy</v-btn></template>
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="dialog = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title class="dialog-title">Privacy Policy</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn class="close-btn" dark text @click="dialog = false">close</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-layout row wrap justify-center>
            <v-flex mt-5 ml-4 mr-3 xs12 sm10 md6>
            <h1>Privacy Policy</h1>
              <p></p>
              <p>Last updated: 12/14/2018</p>
              <p></p>
              <p>Please read this Privacy Policy carefully before using the sheplatform.io.</p>
              <p></p>
              <p>Your access to and use of the Service is conditioned on your acceptance of and compliance with this policy. These Terms apply to all visitors, users and others who access or use the Service.</p>
              <p></p>
              <p><strong>By accessing or using the Service you agree to be bound by these Terms. If you disagree with any part of the terms then you may not access the Service.</strong></p>
              <p><strong></strong></p>
              <p>Our privacy policy: we won't share or sell your email address, and you control access and sharing of your pet info on ShePlatform.</p>
              <p><strong></strong></p>
              <p>Can we make it more simple and transparent than that? We don’t think so.</p>
              <p></p>
              <p><strong>Contact Us</strong></p>
              <p></p>
              <p>If you have any questions about this policy or the use of your information, please contact us at <a href="mailto:team@sheplatform.io">team@sheplatform.io</a></p>
            </v-flex>
          </v-layout>
        </v-card>
      </v-dialog>
</template>

<script>
export default {
  data () {
      return {
        dialog: false
      }
    }
}
</script>

<style>
.platform--header {
    font-family: "Baloo", sans-serif !important;
    font-size: 20px;
    text-transform: none !important;
    font-weight: 400;
}
.v-dialog__content {
  z-index: 9999 !important;
}
.v-list--three-line .v-list__tile {
    height: auto;
    padding-top: 15px;
}
</style>
